import { useQuery } from '@tanstack/react-query';
import { http } from '../lib/fetcher';
import type { MeResponse } from '../api/types';

export function useMe() {
  return useQuery<MeResponse>({
    queryKey: ['me'],
    queryFn: () => http.get<MeResponse>('/me'),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
